import Home from "../views/home/Home.vue";
import PersonalHeader from "../views/personal/PersonalHeader.vue";
import PersonalHeaderV2 from "../views/personal/PersonalHeaderV2.vue";
// import NewsNotice from "../views/home/children/NewsNotice.vue";
import tearch_routes from "./tearch/index"; // 教师路由
import school_train_routes from "./schoolTrain"; // 校培路由
import area_train_routes from "./areaTrain"; // 县培路由
import school_mng_routes from "./schoolMng"; // 校管理路由

const area_router = [{
    path: "/home",
    name: "Home",
    component: Home,
    children: [
        // 首页
        {
            path: "/areahome",
            name: "AreaHome",
            component: () =>
                import(
                    /* webpackChunkName: "areahome" */
                    "../views/home/area_home/AreaHome.vue"
                ),
        },
        
        // 全员项目成果
        {
            path: "/allstaffproject",
            name: "AllStaffProject",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '全员项目成果'
                },]
            },
            component: () =>
                import(
                    /* webpackChunkName: "allstaffproject" */
                    "../views/allstaffproject/AllStaffProject.vue"
                ),
        },
        // 整校推进详情
        {
            path: "/schooladvancedetail",
            name: "AreaHome",
            meta: {
                scrollTop: 1,
                breadCrumd: [{
                    path: '/',
                    name: '整校推荐筛选'
                },
                {
                    path: '/',
                    name: '第一小学'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolAdvanceDetail" */
                    "../views/allstaffproject/children/SchoolAdvanceDetail.vue"
                ),
        },
        // 示范项目成果
        {
            path: "/demonstrateproject",
            name: "DemonstrateProject",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '示范项目成果'
                }]
            },
            component: () =>
                import(
                    /* webpackChunkName: "demonstrateproject" */
                    "../views/demonstrateproject/DemonstrateProject.vue"
                ),
        },
        // 智能领航系列
        {
            path: "/intelligentnavigation",
            name: "DemonstrateProject",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '示范项目成果'
                },
                {
                    path: '/',
                    name: '智能领航系列'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "IntelligentNavigation" */
                    "../views/demonstrateproject/IntelligentNavigation.vue"
                ),
        },
        // 跨学科教学骨干教师培养系列
        {
            path: "/interdisciplinary",
            name: "DemonstrateProject",
            meta: ["示范项目成果", "跨学科教学骨干教师培养系列"],
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '示范项目成果'
                },
                {
                    path: '/',
                    name: '跨学科教学骨干教师培养系列'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "Interdisciplinary" */
                    "../views/demonstrateproject/Interdisciplinary.vue"
                ),
        },
        // 信息化教学创新首席培训师培养系列
        {
            path: "/informationzation",
            name: "DemonstrateProject",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '示范项目成果'
                },
                {
                    path: '/',
                    name: '信息化教学创新首席培训师培养系列'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "Informationzation" */
                    "../views/demonstrateproject/Informationzation.vue"
                ),
        },
        // “双师教学”模式改革培训系列
        {
            path: "/doubletearchteach",
            name: "DemonstrateProject",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '示范项目成果'
                },
                {
                    path: '/',
                    name: '“双师教学”模式改革培训系列'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "DoubleTearchTeach" */
                    "../views/demonstrateproject/DoubleTearchTeach.vue"
                ),
        },
        // 示范项目成果详情
        {
            path: "/sfprojectdetail",
            name: "DemonstrateProject",
            meta: {
                scrollTop: 1,
                breadCrumd: [{
                    path: '/',
                    name: '示范项目成果'
                },
                {
                    path: '/',
                    name: '详情'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SfProjectDetail" */
                    "../views/demonstrateproject/SfProjectDetail.vue"
                ),
        },
        // 示范课堂
        {
            path: "/demonstratecourse",
            name: "DemonstrateCourse",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '示范课堂'
                },]
            },
            component: () =>
                import(
                    /* webpackChunkName: "demonstratecourse" */
                    "../views/demonstrateCourse/DemonstrateCourse.vue"
                ),
        },
        // 直播介绍
        {
            path: "/livestreamintroduce",
            name: "LiveStreamIntroduce",
            meta: {
                scrollTop: 1,
                breadCrumd: [{
                    path: '/',
                    name: '示范课堂'
                },
                {
                    path: '/',
                    name: '直播介绍'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "livestreamintroduce" */
                    "../views/livestreaming/LiveStreamIntroduce.vue"
                ),
        },
        // 新闻公告更多列表
        {
            path: "/NewsNotice",
            name: "AreaHome",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '通知公告列表'
                }
                ]
            },
            // component:NewsNotice,
            component: () =>
                import(
                    /* webpackChunkName: "NoticeMoreList" */
                    "../views/home/children/NewsNotice.vue"
                ),
            children: [
                // 公告更多列表
                {
                    path: "/noticemorelist",
                    name: "AreaHome",
                    meta: {
                        scrollTop: 1,
                        target: 'only',
                        routeName: "onlyNoticeMoreList",
                        breadCrumd: [{
                            path: '/',
                            name: '通知公告列表'
                        }
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "NoticeMoreList" */
                            "../views/home/children/NoticeMoreList.vue"
                        ),
                },
                // 新闻更多列表
                {
                    path: "/newsmorelist",
                    name: "AreaHome",
                    meta: {
                        scrollTop: 1,
                        target: 'only',
                        routeName: "onlyNewsMoreList",
                        breadCrumd: [{
                            path: '/',
                            name: '新闻资讯列表'
                        }
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "newsmorelist" */
                            "../views/home/children/NoticeMoreList.vue"
                        ),
                    children: [],
                },
                // 公告详情
                {
                    path: "/NoticeDetail",
                    name: "AreaHome",
                    meta: {
                        target: 'only',
                        routeName: "onlyNoticeMoreList",
                        breadCrumd: [{
                            path: '/',
                            name: '通知公告列表'
                        },
                        {
                            path: '/',
                            name: '详情'
                        },
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "NoticeMoreList" */
                            "../views/home/children/NoticeDetail.vue"
                        ),
                },

                // 新闻详情
                {
                    path: "/NewsDetail",
                    name: "AreaHome",
                    meta: {
                        target: 'only',
                        routeName: "onlyNewsMoreList",
                        breadCrumd: [{
                            path: '/',
                            name: '新闻资讯列表'
                        },
                        {
                            path: '/',
                            name: '详情'
                        },
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "NoticeMoreList" */
                            "../views/home/children/NoticeDetail.vue"
                        ),
                },
            ],
        },

        // 整校推进筛选
        {
            path: "/schooladvancefilter",
            name: "SchoolAdvanceFilter",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进筛选'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolAdvanceFilter" */
                    "../views/home/children/SchoolAdvanceFilter.vue"
                ),
        },
        // 微能力成果详情
        {
            path: "/abilityachievementdetail",
            name: "AllStaffProject",
            meta: {
                scrollTop: 1,
                breadCrumd: [{
                    path: '/',
                    name: '微能力成果'
                },
                {
                    path: '/',
                    name: '详情'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityAchievementDetail" */
                    "../views/home/children/AbilityAchievementDetail.vue"
                ),
        },
        // 微能力成果更多
        {
            path: "/abilitymore",
            name: "AreaHome",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '微能力成果'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityMore" */
                    "../views/home/children/AbilityMore.vue"
                ),
        },
        // 录播课详情
        {
            path: "/lubdetail",
            name: "LuBDetail",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '示范课堂'
                },
                {
                    path: '/',
                    name: '详情'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "LuBDetail" */
                    "../views/livestreaming/LuBDetail.vue"
                ),
        },
        // 个人中心头部
        {
            path: "/personalheader",
            name: "PersonalHeader",
            meta: ["个人中心"],
            component: PersonalHeader,
            children: [],
        },
        {
            path: "/personalheaderv2",
            name: "PersonalHeaderV2",
            meta: ["个人中心"],
            component: PersonalHeaderV2,
            children: [],
        },
    ],
},
// 直播间
{
    path: "/liveroom",
    name: "LiveRoom",
    component: () =>
        import(
            /* webpackChunkName: "LiveRoom" */
            "../views/livestreaming/LiveRoom.vue"
        ),
},
];

// 路由合并
// area_router[0].children = area_router[0].children.concat(tearch_routes)

let target = area_router[0].children.find((item) => {
    return item.path == "/personalheader";
});
let targetV2 = area_router[0].children.find((item) => {
    return item.path == "/personalheaderv2";
});

// 获取本地信息
let webUserInfo = {};
let role = "";
if (localStorage.getItem("webUserInfo")) {
    webUserInfo = JSON.parse(localStorage.getItem("webUserInfo"));
    role = webUserInfo.role;
}
// 1教师 2校培 3县培 4市培 5校管理员
if (role == 1) {
    // 合并个人中心教师的路由
    target.children = target.children.concat(tearch_routes[0]);
    targetV2.children = targetV2.children.concat(tearch_routes[1]);
} else if (role == 2) {
    target.children = target.children.concat(school_train_routes[0]);
    targetV2.children = targetV2.children.concat(school_train_routes[1]);
} else if (role == 3 || role == 4) {
    target.children = target.children.concat(area_train_routes[0]);
    targetV2.children = targetV2.children.concat(area_train_routes[1]);
} else if (role == 5) {
    target.children = target.children.concat(school_mng_routes[0]);
    targetV2.children = targetV2.children.concat(school_mng_routes[1]);
}

export default area_router;